var ko = require('knockout');
var stringTemplateEngine = require('knockout-template-loader/lib/string-template-engine');
var htmlContent = "<span class=\"mdl-textfield__error\" data-bind=\"click: showValidationError.bind($data, $element, field)\">\r\n    <i class=\"material-icons notranslate\">info</i>\r\n</span>";
ko.templates['validation-error-template-html'] = htmlContent;


//////////////////
// WEBPACK FOOTER
// ./Scripts/Templates/validation-error-template.html
// module id = 182
// module chunks = 3